import React, { useMemo } from "react";
import { Container, Col, Row, Table } from "reactstrap";
import { Link } from "react-router-dom";
import { useQuery } from "@apollo/client";
import _get from "lodash/get";
import * as Loading from "@repoflow/components/loading";
import * as Section from "@repoflow/components/section";
import * as BlogQL from "queries/blog";
import { TEMPLATE_LABELS, TEMPLATE_DESCRIPTIONS } from "../kinds";

export const Sidebar = () => null;
export const Indice = () => null;

// THE THREE TEMPLATES, always three. There is nothing to add and nothing to
// remove here — every site has a post, a list and a collection template from
// the start, the built-in until somebody writes one — so this is a table of
// what each is for and whether it has been changed, not a listing of rows.
export const Content = ({
  match: {
    params: { siteId },
  },
}) => {
  const { base } = Section.useSectionContext();
  const { data, loading } = useQuery(BlogQL.templates, {
    variables: { siteId },
    fetchPolicy: "cache-and-network",
  });
  const templates = useMemo(
    () => _get(data, "viewer.account.sites.get.blog.templates") || [],
    [data]
  );

  if (loading && !data) {
    return <Loading.Content />;
  }

  return (
    <Container className="mt-4">
      <Row>
        <Col>
          <p className="text-muted">
            The blog's elements render through these. Each one starts as the
            built-in and can be rewritten here; a template reads the post, the
            listing or the collection as <code>values</code>.
          </p>
          <Table hover responsive>
            <thead>
              <tr>
                <th>Template</th>
                <th>Shows</th>
                <th>Status</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {templates.map(({ kind, builtin }) => (
                <tr key={kind} data-template={kind}>
                  <th scope="row">{TEMPLATE_LABELS[kind] || kind}</th>
                  <td>{TEMPLATE_DESCRIPTIONS[kind] || ""}</td>
                  <td>
                    <span
                      className={builtin ? "badge badge-secondary" : "badge badge-success"}
                      data-status={builtin ? "builtin" : "custom"}
                    >
                      {builtin ? "Built-in" : "Customised"}
                    </span>
                  </td>
                  <td className="text-right">
                    <Link className="btn btn-primary btn-sm" to={`${base}/${kind}/edit`}>
                      Edit
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Col>
      </Row>
    </Container>
  );
};
